import { ActionButton } from "../../../../components-common/buttons/ActionButton";
import { observer } from "mobx-react";
import React, { FC } from "react";

type IBuildingTableHeader = {
  componentName?: "spaceFunction";
  addTo?: "interior" | "exterior" | "core";
  showAddNew: boolean;
  addNewFn: () => void;
};

const BuildingTableHeader: FC<IBuildingTableHeader> = observer(
  ({ componentName, addNewFn, showAddNew, addTo, ...props }) => {
    const headerValues = ["Material", "Function", "Thickness"];
    return (
      <>
        <div className={"row-element"}>
          {headerValues.map((headerEl: string, index: number) => (
            <div className={"structure-cell Parameter-header"} key={index}>
              {headerEl}
            </div>
          ))}
          {showAddNew ? (
            <div className="structure-cell d-flex justify-content-end cell ebd-icon">
              <ActionButton
                kind="add"
                onAction={() => {
                  addNewFn();
                }}
                visual="icon"
                className="cursor-pointer"
              />
            </div>
          ) : (
            <div className={"cell"}></div>
          )}
        </div>
      </>
    );
  }
);

export default BuildingTableHeader;
